const state = () => ({
  mensajeNotificacion : "",
  colorNotifificacion : "error",
  snackbar : false, 

})

const getters = {
  getmensajeNotificacion: ( state ) => {
    return state.mensajeNotificacion;
  },
  getmensajeColor: ( state ) => {
    return state.colorNotifificacion;
  },
  getsnackbar: (state) => {
    return state.snackbar;
  },
} 

const mutations = {
  MENSAJE : ( state, estado ) => {
    state.mensajeNotificacion = estado;
  },
  COLOR : ( state, estado ) => {
    state.colorNotifificacion = estado;
  },
  NOTIFICAR : ( state, estado ) => {
    state.snackbar = estado;
  },
}

const actions = {
  SetMensaje( {commit}, estado ) {
    commit( "MENSAJE", estado );
  },
  SetColor( {commit}, estado ) {
    commit( "COLOR", estado );
  },
  ShowNotificacion( {commit}, estado ) {
    commit("NOTIFICAR", estado);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}